/*******************************************************************************
 * Project：WDCK
 * Summary:
 *　　 Login function
 * History：
 *      AnBD            2021/08/31    Create new
******************************************************************************/
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { SrcExamLoginService } from '../src-exam-login/src-exam-login.service';
import { LoadingService } from '../../../../layout/loading/loading.service';
import { DialogModalService } from '../../../../shared/dialog-modal/dialog-modal.service';
import { Utility } from '../../../../shared/utility/utility';
import { UserLoginInfoDto } from '../../../../models/UserLoginInfoDto';
import { finalize } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { QueryParams, rgxKanaFullW, rgxKanaHalfW } from 'src/app/shared/constant';
@Component({
  selector: 'app-src-exam-login',
  templateUrl: './src-exam-login.component.html',
  styleUrls: ['./src-exam-login.component.scss']
})
export class SrcExamLoginComponent implements OnInit, OnDestroy {
  @Output() closeModal = new EventEmitter<void>();
  maillAdress: string;
  password = '';
  loginData: any;
  clicked = false;
  ngUnsubscribe = new Subject();
  isPass = false;
  messErr = '';
  messErr2 = '';
  LocalPass: any;
  isCheck = false;
  isLoginErr = false;
  isEmail = false;
  realText = '';
  isLoad = false;
  url: string;
  consulIdPR: string;
  id0106: string;
  id0104: string;
  constructor(
    private modalService: NgbModal,
    private auth: SrcExamLoginService,
    private loadingSrv: LoadingService,
    private util: Utility,
    private dialogModalService: DialogModalService,
    private translate: TranslateService,
    private router: Router,
    private routeActived: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.util.addPerfectScrollBar();

    this.id0106 = sessionStorage.getItem('id0106');
    this.id0104 = sessionStorage.getItem('id0104');

    if (!this.util.isNullOrEmpty(sessionStorage.getItem('exam-authen-email'))) {
      this.maillAdress = sessionStorage.getItem('exam-authen-email');
      sessionStorage.removeItem('exam-authen-email');
      this.isLoad = true
    } else {      
      if (this.util.isNullOrEmpty(sessionStorage.getItem('Logout'))) {
        this.getToken();
        this.isLoad = true;
      }
      else {
        sessionStorage.removeItem('Logout');
        this.isLoad = true;
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getToken() {
    this.loadingSrv.setDisplay(true);
    this.auth.GetToken().subscribe(
      value => {
        this.isLoad = true;
        this.loadingSrv.setDisplay(false);
        if (!this.util.isNullOrEmpty(value)) {
          const data = JSON.parse(value);
          const saveInfo: any = {};
          saveInfo.UserID = data.UserID?.trim();
          saveInfo.MailAdress = data.MailAdress?.trim();
          saveInfo.Name = data.Name?.trim();
          saveInfo.KanaName = data.KanaName?.trim();
          saveInfo.DateOfBirth = data.DateOfBirth?.trim();
          saveInfo.Gender = data.Gender.trim();
          saveInfo.PhoneNum = data.PhoneNum?.trim();
          saveInfo.PostalCode = data.PostalCode?.trim();
          saveInfo.Adress1 = data.Adress1?.trim();
          saveInfo.Adress2 = data.Adress2?.trim();
          saveInfo.RegistrationDiv = data.RegistrationDiv?.trim();
          saveInfo.CountryCode = data.CountryCode?.trim();
          localStorage.ExamineauthorizationData = JSON.stringify(saveInfo);
          localStorage.fLogin = 'true';
          const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
          const Consulday = this.routeActived.snapshot.queryParams[QueryParams.ConsulDay];
          const Consulnum = this.routeActived.snapshot.queryParams[QueryParams.ConsulNum];
          const url = this.routeActived.snapshot.queryParams.continue;
          if (!this.util.isNullOrEmpty(url) && url === 'insurance-sel' && !this.util.isNullOrEmpty(htOrgCode)) {
            this.router.navigate([url], {
              queryParams: {
                htorgcode: htOrgCode
              }
            });
          } else if (!this.util.isNullOrEmpty(htOrgCode) && !this.util.isNullOrEmpty(Consulday) && !this.util.isNullOrEmpty(Consulnum)) {
            this.router.navigate(['scr-exam-result'], {
              queryParams: {
                consulday: Consulday, consulnum: Consulnum, htorgcode: htOrgCode
              }
            });
          } else if (!this.util.isNullOrEmpty(htOrgCode)) {
            //case login roi => nhap data matching
            if(!this.util.isNullOrEmpty(this.id0106))
            {
              this.router.navigateByUrl('toppage');
              sessionStorage.removeItem('id0106');
            }
            else{
              this.router.navigate(['insurance-sel'], {
                queryParams: {
                  htorgcode: htOrgCode
                }
              });
            }            
          }
          else {
            this.router.navigateByUrl('toppage');
          }
        }
        else {
          const id = JSON.parse(sessionStorage.getItem('is0106'));
          localStorage.clear();
          sessionStorage.clear();
          localStorage.fLogin = 'false';
          sessionStorage.setItem('is0106', id);
        }
      }, err => {
        this.isLoad = true;
        localStorage.removeItem('SavePass');
        this.loadingSrv.setDisplay(false);
        this.router.navigateByUrl('/');
      });
  }

  inputValidate() {
    let isValidate = false;
    if (this.util.isNullOrEmpty(this.maillAdress)) {
      this.isEmail = true;
      isValidate = true;
      this.messErr = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_EMAIL_ADDRESS'));
    }
    else {
      this.isEmail = false;
    }
    if (this.util.isNullOrEmpty(this.password)) {
      this.isPass = true;
      isValidate = true;
      this.messErr2 = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_PASSWORD'));
    }
    else {
      this.isPass = false;
    }
    return isValidate;
  }

  Login() {

    if (this.inputValidate()) {
      return;
    }
    this.loadingSrv.setDisplay(true);
    const sLoginData = new UserLoginInfoDto();

    sLoginData.MailAdress = this.maillAdress;
    sLoginData.SavePass = this.isCheck;
    
    try {
      sLoginData.Password = window.btoa(this.password);
    } catch (error) {
      this.loadingSrv.setDisplay(false);
      this.isPass = true;
      this.isLoginErr = true;
      this.isEmail = false;
      this.messErr2 = 'MESS_ERR_MAIL_OR_PW_WRONG';
      $('#passLogin').val('');
    }

    this.auth.login(sLoginData).pipe(
      finalize(() => {
        this.loadingSrv.setDisplay(false);
      })
    ).subscribe(data => this.loginData = data, (error) => {
      this.dialogModalService.openErrorModal(this.translate.instant('MESS_ERR_SERVER_TIMEOUT'));
    }, async () => {
      if (this.loginData != null && this.loginData.LoginFailTimes === 0) {
        this.isLoginErr = false;
        this.onModalClose();
        const saveInfo: any = {};
        saveInfo.UserID = this.loginData.UserID?.trim();
        saveInfo.MailAdress = this.loginData.MailAdress?.trim();
        saveInfo.Name = this.loginData.Name?.trim();
        saveInfo.KanaName = this.loginData.KanaName?.trim();
        saveInfo.DateOfBirth = this.loginData.DateOfBirth?.trim();
        saveInfo.Gender = this.loginData.Gender.trim();
        saveInfo.PhoneNum = this.loginData.PhoneNum?.trim();
        saveInfo.PostalCode = this.loginData.PostalCode?.trim();
        saveInfo.Adress1 = this.loginData.Adress1?.trim();
        saveInfo.Adress2 = this.loginData.Adress2?.trim();
        saveInfo.RegistrationDiv = this.loginData.RegistrationDiv?.trim();
        saveInfo.CountryCode = this.loginData.CountryCode?.trim();
        localStorage.ExamineauthorizationData = JSON.stringify(saveInfo);
        localStorage.fLogin = 'true';
        this.isPass = false;

        const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
        const Consulday = this.routeActived.snapshot.queryParams[QueryParams.ConsulDay];
        const Consulnum = this.routeActived.snapshot.queryParams[QueryParams.ConsulNum];
        const Consulid = this.routeActived.snapshot.queryParams[QueryParams.Consulid];
        const url = this.routeActived.snapshot.queryParams.continue;

        if (!this.util.isNullOrEmpty(this.id0106) ||!this.util.isNullOrEmpty(this.id0104)) {

          if (!this.util.isNullOrEmpty(this.id0104)) {
            
            const value = new UserLoginInfoDto();
            value.HTOrgCode = htOrgCode;
            value.UserID = this.loginData?.UserID?.trim();
            //value.ConsulID = this.routeActived.snapshot.queryParams[QueryParams.ConsulId];
            value.ConsulID = this.id0106;
            this.auth.UpdateInfoUser(value).subscribe(data => {
              if (data){                
                this.router.navigateByUrl('toppage');
                sessionStorage.removeItem('id0104');
              }
            }, err => {});
          }
          else if (!this.util.isNullOrEmpty(this.id0106)) {
          //const id = sessionStorage.getItem('id0106');
          const id = this.id0106;

          if (id?.toString()?.trim() === this.loginData?.UserID?.trim()) {
            this.router.navigateByUrl('toppage');
            sessionStorage.removeItem('id0106');
          } else {
            const cnf = await this.dialogModalService.openConfirmModal(this.translate.instant('MESS_CNF_EXMINF_NOTSAME_USERINF'))
            .toPromise();
            if (cnf.buttonName === 'ok') {
              // khong update
              this.router.navigateByUrl('toppage');
              sessionStorage.removeItem('id0106');

              // update
              // const value = new UserLoginInfoDto();
              // value.HTOrgCode = htOrgCode;
              // value.UserID = this.loginData?.UserID?.trim();
              // value.ConsulID = this.routeActived.snapshot.queryParams[QueryParams.ConsulId];
              // this.auth.UpdateInfoUser(value).subscribe(data => {
              //   if (data){
              //     this.router.navigateByUrl('toppage');
              //     sessionStorage.removeItem('id0106');
              //   }
              // }, err => {});

            }else{
              return;
            }
          }
        }
      }
      else if (!this.util.isNullOrEmpty(url) && url === 'insurance-sel' && !this.util.isNullOrEmpty(htOrgCode)) {
          this.router.navigate([url], {
            queryParams: {
              htorgcode: htOrgCode
            }
          });
        } else if (!this.util.isNullOrEmpty(htOrgCode) && !this.util.isNullOrEmpty(Consulday) && !this.util.isNullOrEmpty(Consulnum)) {
          this.router.navigate(['scr-exam-result'], {
            queryParams: {
              consulday: Consulday, consulnum: Consulnum, htorgcode: htOrgCode
            }
          });
        }
        else if (!this.util.isNullOrEmpty(htOrgCode)) {
          this.router.navigate(['insurance-sel'], {
            queryParams: {
              htorgcode: htOrgCode
            }
          });
        }
        else{
          this.router.navigateByUrl('toppage');
        }
        if (this.isCheck === true) {
          localStorage.setItem('SavePass', this.maillAdress);
        } else {
          localStorage.removeItem('SavePass');
        }
      }
      else if (this.loginData == null) {
        this.isPass = true;
        this.isLoginErr = true;
        this.messErr2 = 'MESS_ERR_MAIL_OR_PW_WRONG';
        this.password = '';
        $('#passLogin').val('');
      }
      if (!this.util.isNullOrEmpty(this.loginData?.StrErr)) {
        if (this.loginData.StrErr === 'L') {
          sessionStorage.Time10Err = JSON.stringify('True');
          const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
          this.router.navigate(['src-pw-forgot'], {
            queryParams: {
              htorgcode: htOrgCode
            }
          });
        }
        if (this.loginData.StrErr === 'P') {
          this.isPass = true;
          this.isLoginErr = true;
          this.messErr2 = 'MESS_ERR_MAIL_OR_PW_WRONG';
          this.password = '';
          $('#passLogin').val('');
        }
      }
    });
  }

  onModalClose(): void {
    this.closeModal.emit();
  }

  RemoveErr(id: number) {
    if (id === 1) {
      this.isEmail = false;
    }
    if (id === 2) {
      this.isPass = false;
    }
  }

  regis() {
    let htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    let consulId = this.routeActived.snapshot.queryParams[QueryParams.ConsulId];
    if (consulId === undefined) {
      consulId = null;
    }
    if (htOrgCode === undefined) {
      htOrgCode = null;
    }
    this.router.navigate(['/sending-authen-mail'], { queryParams: { htorgcode: htOrgCode, consulid: consulId } });
  }

  toLowerCase() {
    this.maillAdress = this.maillAdress?.toLowerCase();
  }

  resetPass() {
    const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    if (this.util.isNullOrEmpty(htOrgCode)) {
      this.url = 'src-pw-forgot';
    } else {
      this.url = 'src-pw-forgot?htorgcode=' + htOrgCode;
    }
  }
  
  MaskPass(e: any) {
    const preVal = this.password;
    const index = e.target.selectionStart;
    let nowVal = e.target.value;
    const kanaText = e.data;
    if (e.which === 32) {
      nowVal = nowVal?.replace(/\s/g, '');
    }
    if (this.check2ByteFunc(kanaText)) {
      nowVal = nowVal?.replace(kanaText, '');
    }
    const incre = nowVal.length - preVal.length;
    // increase text
    if (incre > 0) {
      const newStr = nowVal.slice(index - incre, index);
      this.password = preVal.slice(0, index - incre) + newStr + preVal.slice(index - incre);
      // delete text
    } else if (incre < 0) {
      this.password = preVal.slice(0, index) + preVal.slice(index - incre);
    }

    // render mask effect
    if (nowVal.length > 0) {
      e.target.value = this.pointGen('●', nowVal.length - 1) + nowVal.charAt(nowVal.length - 1);
      setTimeout(() => {
        e.target.value = '●'.repeat(e.target.value.length);
      }, 1000);
    } else {
      $(e.target).val('');
    }
    e.target.setSelectionRange(index, index);
  }
  pointGen(pattern: string, num: number) {
    // tslint:disable-next-line:only-arrow-functions
    return Array.apply(null, Array(num)).map(function () { return pattern; }).join('');
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
  }
  countLength(str) {
    let r = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
      // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        r += 1;
      } else {
        r += 2;
      }
    }
    return r;
  }
  check2ByteFunc(val) {
    const actualLen = val.length;
    const strLen = this.countLength(val);
    // tslint:disable-next-line: radix
    if (parseInt(actualLen) * 2 === strLen) {
      return true;
    }
    return false;
  }

  checkPwd(e) {
    let nowVal = e.target.value;
    const kanaText = e.data;
    if (e.which === 32) {
      nowVal = nowVal?.replace(/\s/g, '');
    }
    if (this.check2ByteFunc(kanaText)) {
      nowVal = nowVal?.replace(kanaText, '');
    }
    e.target.value = nowVal;
  }
  onKeyTodo(event: any) {
    const keyValues = event.target.value;
    if (this.check2ByteFunc(keyValues)) {
      // tslint:disable-next-line: only-arrow-functions
      event.target.value = keyValues.replace(/[\uFF00-\uFFFE]/g, function (char) {
        if (char >= '\uFF00' && char <= '\uFF5E') {
          return String.fromCharCode(
            ' '.charCodeAt(0) +
            (char.charCodeAt(0) - '\uFF00'.charCodeAt(0)));
        }
        return '';
      });
    }
  }
}
